<div class="notifications-container">
  @if (isLoading()) {
    <!-- Loading state -->
    <app-loading-card [loadingText]="'TGA.Notifications.Loading'" />
  } @else {
    <!-- Warnings Section -->
    @if (warnings().length > 0) {
      <div class="notifications-header">
        <p class="notifications-title">
          <strong>{{ warnings().length }} {{ 'TGA.Notifications.WarningsTitle' | translate }}</strong>
        </p>
        @if (hasDismissedWarnings()) {
          <button mat-button class="history-button" (click)="navigateToHistory('warnings')">
            <mat-icon>arrow_forward</mat-icon>
            {{ 'TGA.Notifications.ViewHistory' | translate }}
          </button>
        }
      </div>
      <div class="notifications-scroll">
        @for (notification of warnings(); track notification.type) {
          <app-notification-card [notification]="notification" class="notification-item" />
        }
      </div>
    } @else {
      @if (hasDismissedWarnings()) {
        <div class="notifications-header">
          <p class="notifications-title">{{ 'TGA.Notifications.NoWarningsMessage' | translate }}</p>
          <button mat-button class="history-button" (click)="navigateToHistory('warnings')">
            <mat-icon>arrow_forward</mat-icon>
            {{ 'TGA.Notifications.ViewHistory' | translate }}
          </button>
        </div>
      }
    }

    <!-- Notifications Section -->
    @if (messages().length > 0) {
      <p class="section-title">
        <strong>{{ 'TGA.Notifications.SectionTitle' | translate }}</strong>
      </p>
      <div class="notifications-header">
        <p class="notifications-title">
          <strong>{{ messages().length }} {{ 'TGA.Notifications.MeldingenTitle' | translate }}</strong>
        </p>
        @if (hasDismissedMessages()) {
          <button mat-button class="history-button" (click)="navigateToHistory('messages')">
            <mat-icon>arrow_forward</mat-icon>
            {{ 'TGA.Notifications.ViewHistory' | translate }}
          </button>
        }
      </div>
      <div class="notifications-scroll">
        @for (notification of messages(); track notification.type) {
          <app-notification-message-card
            [notification]="notification"
            (notificationDismissed)="onNotificationDismissed($event)"
            class="notification-item"
          />
        }
      </div>
    } @else {
      <!-- Show empty notifications section with history button if there are dismissed messages -->
      @if (hasDismissedMessages()) {
        <p class="section-title">
          <strong>{{ 'TGA.Notifications.SectionTitle' | translate }}</strong>
        </p>
        <div class="notifications-header">
          <p class="notifications-title">{{ 'TGA.Notifications.NoMeldingenMessage' | translate }}</p>
          <button mat-button class="history-button" (click)="navigateToHistory('messages')">
            <mat-icon>arrow_forward</mat-icon>
            {{ 'TGA.Notifications.ViewHistory' | translate }}
          </button>
        </div>
      }
    }
  }
</div>
